import { render, staticRenderFns } from "./tareasprogramadas.vue?vue&type=template&id=633a116a"
import script from "./tareasprogramadas.vue?vue&type=script&lang=js"
export * from "./tareasprogramadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports